import { useEffect, useState } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { Col, Grid, Row } from 'antd';

import BannerHeader from 'src/components/BannerHeader';
import ArticleSection from 'src/components/Home/Article';
import ImageC from 'src/components/Image';
import { RESULT_CHECK_HEALTHTOOLS } from 'src/constants/localStorage';
import { articlesRecords } from 'src/containers/CancerRisk/cancer-risk-data';
import { HeartDiseaseTypes } from 'src/utils/dummy/medical-appointment/appoinment';
import { pushWithQS } from 'src/utils/func/push-with-qs';

const ResikoJantung = (props: any) => {
	const { router } = props;
	const { xs, sm, md, xl, lg } = Grid.useBreakpoint();
	const { homepage } = useSelector((state: RootStateOrAny) => state);
	const [tabActive, setTabActive] = useState<string>('');
	const responsive = (xs || sm || md) && !lg;
	const heartDeseaseImg = responsive ? 122 : 178;
	const heartDeseaseImgSize = xl ? 230 : heartDeseaseImg;

	const dataAds = homepage.banner?.data?.record?.ads?.ads || [];
	const showArticleSection = false;

	const onChangeTab = (e: any) => {
		const key = e?.key ? e?.key : e;
		setTabActive(key);
	};

	const onClickCheck = () => {
		pushWithQS(router, '/jaga-jantung/cek');
	};

	useEffect(() => {
		localStorage.removeItem(RESULT_CHECK_HEALTHTOOLS);
	}, []);

	const ListTahukah = () => {
		return (
			<div className="mt-2 sm:mt-0">
				<h4 className="font-semibold text-2xl mb-2">Tahukah kamu</h4>
				<ul className="list-none pl-0 space-y-2">
					<li>
						<Row
							style={{
								display: 'flex',
							}}
						>
							<Col span={2}>
								<ImageC alt="icon" src="/icons/green-li.svg" width={24} height={24} />
							</Col>
							<Col span={22}>
								<p className="not-italic font-normal leading-normal tracking-[0.15px] text-neutral text-xs sm:text-sm md:text-base">
									Penyakit jantung merupakan penyakit penyebab kematian nomor 1 baik secara global
									maupun nasional di Indonesia
								</p>
							</Col>
						</Row>
					</li>
					<li>
						<Row
							style={{
								display: 'flex',
							}}
						>
							<Col span={2}>
								<ImageC alt="icon" src="/icons/green-li.svg" width={24} height={24} />
							</Col>
							<Col span={22}>
								<p className="not-italic font-normal leading-normal tracking-[0.15px] text-neutral text-xs sm:text-sm md:text-base">
									Peningkatan potensi serangan jantung umumnya terjadi pada rentang usia 20 - 30
									tahun berdasarkan American College of Cardiology
								</p>
							</Col>
						</Row>
					</li>
				</ul>
			</div>
		);
	};

	return (
		<div className="bg-white">
			<BannerHeader
				{...props}
				description="Ketahui kondisi risiko jantungmu saat ini. Cari tahu sekarang!"
				name={['Kenali Dirimu dan Cek Risiko Jantung Sebelum Terlambat']}
				backgroundImage="/images/resiko_jantung/resiko-jantung-header-bg.jpg"
				buttonColor="#00a376"
				buttonText="Cek Risiko Jantung"
				onClick={onClickCheck}
				title="Jaga Jantung"
				breadcrumbs={[{ label: 'Jaga Jantung' }]}
				isTextShadow={true}
			/>

			<Col className="container">
				<h2 className="text-neutral text-center font-bold tracking-normal text-lg leading-[140%] xs:text-2xl xs:leading-8 md:text-[38px] md:leading-[47px] mt-12.5">
					Jantungmu, Hidupmu.
				</h2>
				<h2 className="text-neutral text-center font-bold tracking-normal text-lg leading-[140%] xs:text-2xl xs:leading-8 md:text-[38px] md:leading-[47px]">
					Jaga Kesehatan Jantung Mulai dari Sekarang!
				</h2>
				<Row className="my-2">
					{xs ? (
						<>
							<Col span="24">
								<div style={{ height: 290 }}>
									<ImageC
										src="/images/resiko_jantung/penyakit-mobile.png"
										alt="penyakit"
										fill
										style={{ objectFit: 'contain' }}
									/>
								</div>
							</Col>
							<Col span="24">
								<ListTahukah />
							</Col>
						</>
					) : (
						<>
							<Col span="12" className="self-center">
								<ListTahukah />
							</Col>
							<Col span="12">
								<div style={{ height: 585 }}>
									<ImageC
										src="/images/resiko_jantung/penyakit.png"
										alt="penyakit"
										fill
										style={{ objectFit: 'contain' }}
									/>
								</div>
							</Col>
						</>
					)}
				</Row>
			</Col>
			<div className="bg-gradient-to-b from-[#f7f9fa]/0 via-[#f7f9fa]/0 to-[#f7f9fa] mt-16">
				<div className="container space-y-4" style={{ alignContent: 'center' }}>
					<h2 className="text-neutral text-center font-bold tracking-normal text-lg leading-[140%] xs:text-2xl xs:leading-8 md:text-[38px] md:leading-[47px]">
						Ragam Jenis Penyakit Jantung
					</h2>
					<h5 className="text-neutral text-center font-normal leading-[21px] tracking-[0.15px] mx-auto w-full text-xs sm:w-[60vw] sm:text-sm md:text-base">
						Pelajari lebih lanjut mengenai ragam penyakit jantung dari segi medis. Tambah
						pengetahuanmu agar lebih mudah menghindarinya agar tercapai hidup sehat.
					</h5>
					<Row className="text-center mt-5 mx-auto w-[274.2px] xs:w-[411px] md:w-[529.07px] lg:w-auto" justify="space-around">
						{HeartDiseaseTypes.map((it, key) => (
							<Col key={key} xs={12} sm={6} md={6}>
								<div className='flex justify-center'>
									<ImageC
									alt="example"
									src={it.image_url}
									className="object-cover max-w-[230px] rounded-2xl w-[133px] h-[133px] md:w-[122px] md:h-[122px] lg:w-[133px] lg:h-[133px] xl:w-[178px] xl:h-[178px] 2xl:w-[230px] 2xl:h-[230px]"
									width={heartDeseaseImgSize}
									height={heartDeseaseImgSize}
								/>
								</div>
								<p className="font-semibold text-center text-xs leading-5 xs:leading-[30px] md:text-lg md:leading-12">{it.name}</p>
							</Col>
						))}
					</Row>
				</div>
				{showArticleSection ? (
					<>
						<div>
							<h2 className="text-neutral text-center font-bold tracking-normal text-lg leading-[140%] xs:text-2xl xs:leading-8 md:text-[38px] md:leading-[47px]">
								Artikel Risiko Jantung Terkini
							</h2>
							<h5 className="text-neutral text-center font-normal leading-[21px] tracking-[0.15px] mx-auto w-full text-xs sm:w-[60vw] sm:text-sm md:text-base">
								Ragam informasi seputar penyakit dan risiko penyakit jantung. Diulas oleh dokter dan
								ahli kesehatan tepercaya!
							</h5>
							<ArticleSection
								isSetHeight={true}
								categoryTopic={[]}
								articles={articlesRecords}
								onChange={onChangeTab}
								activeKey={tabActive}
								ads={dataAds}
								isNoneSectionTitle={true}
							/>
						</div>
					</>
				) : (
					<div className="bg-white py-2"></div>
				)}
			</div>
		</div>
	);
};

export default ResikoJantung;
